(function fiscalColombiaModule(window, document) {
  "use strict";

  var MODULE_NAME = "EusariFiscalColombia";
  var STORAGE_KEY = "eusari:fiscal-colombia:pending";
  var DEFAULT_COUNTRY = {
    code: "CO",
    name: "Colombia",
    documentType: "NIT o Cédula",
  };
  var DEFAULT_PRODUCT_DESCRIPTION_ES =
    "Suplemento alimenticio en cápsulas con ingredientes naturales. No es medicamento ni producto farmacéutico.";
  var DEFAULT_PRODUCT_DESCRIPTION_EN =
    "Dietary supplement in capsules with natural ingredients. Not a medicine or pharmaceutical product.";
  var DEFAULT_HS_CODE = "2106.90.99";
  var DEFAULT_WEBHOOK_TIMEOUT_MS = 5000;
  var DEFAULT_CHECKOUT_PATH = "checkout";

  var COLOMBIA_PACKS = {
    1: {
      pack_label: "1 ud",
      web_price_usd: "45.00",
      freight_usd: "16.79",
      fob_total_usd: "28.21",
      fob_unit_usd: "28.21",
      cif_usd: null,
      cif_note: null,
      tax_type: "Exempt",
      tax_rate: "0",
      tax_amount_usd: "0.00",
      total_amount_usd: "45.00",
      total_type: "DDP",
    },
    2: {
      pack_label: "2 uds",
      web_price_usd: "80.00",
      freight_usd: "16.79",
      fob_total_usd: "63.21",
      fob_unit_usd: "31.61",
      cif_usd: null,
      cif_note: null,
      tax_type: "Exempt",
      tax_rate: "0",
      tax_amount_usd: "0.00",
      total_amount_usd: "80.00",
      total_type: "DDP",
    },
    3: {
      pack_label: "3 uds",
      web_price_usd: "105.00",
      freight_usd: "16.79",
      fob_total_usd: "88.21",
      fob_unit_usd: "29.40",
      cif_usd: null,
      cif_note: null,
      tax_type: "Exempt",
      tax_rate: "0",
      tax_amount_usd: "0.00",
      total_amount_usd: "105.00",
      total_type: "DDP",
    },
  };

  var state = {
    config: null,
    record: null,
    pendingSubmit: null,
    pendingCartAdd: null,
    isProcessing: false,
  };

  function toStringValue(value) {
    return value == null ? "" : String(value);
  }

  function normalizeDocument(value) {
    return toStringValue(value).trim().replace(/[.\s]/g, "");
  }

  function validateFiscalDocument(value) {
    var normalized = normalizeDocument(value);

    return (
      /^[0-9]{7,10}$/.test(normalized) || /^[0-9]{7,10}-[0-9]$/.test(normalized)
    );
  }

  function resolvePackQuantity(productContext) {
    var contextQuantity = parseInt(
      productContext && productContext.pack_quantity,
      10,
    );
    var selectedItem;
    var label;
    var match;

    if (contextQuantity >= 1 && contextQuantity <= 3) return contextQuantity;

    selectedItem = document.querySelector(".ab-volume-discount-item-selected");
    label =
      selectedItem &&
      selectedItem.querySelector(".ab-volume-discount-item-title-label");
    match = label && label.textContent && label.textContent.match(/\d+/);

    if (match) {
      contextQuantity = parseInt(match[0], 10);
      if (contextQuantity >= 1 && contextQuantity <= 3) return contextQuantity;
    }

    return 1;
  }

  function getColombiaPackData(packQuantity) {
    return COLOMBIA_PACKS[packQuantity] || COLOMBIA_PACKS[1];
  }

  function ensureExemptTaxAmount(pricingData) {
    var normalized = Object.assign({}, pricingData);

    if (normalized.tax_type === "Exempt") {
      normalized.tax_amount_usd = "0.00";
    }

    return normalized;
  }

  function buildWebhookPayload(record, productContext) {
    var context = productContext || {};
    var packQuantity = resolvePackQuantity(context);
    var pricingData = ensureExemptTaxAmount(getColombiaPackData(packQuantity));
    var payload = Object.assign(
      {
        document: normalizeDocument(record && record.document),
        document_type:
          (record && record.documentType) || DEFAULT_COUNTRY.documentType,
        country: DEFAULT_COUNTRY.code,
        country_name: DEFAULT_COUNTRY.name,
        variant_id: toStringValue(
          context.variant_id ||
            context.variantId ||
            (state.config && state.config.variantId),
        ),
        product_id: toStringValue(
          context.product_id ||
            context.productId ||
            (state.config && state.config.productId),
        ),
        pack_quantity: packQuantity,
        description_es:
          context.description_es ||
          context.descriptionEs ||
          (state.config && state.config.descriptionEs) ||
          DEFAULT_PRODUCT_DESCRIPTION_ES,
        description_en:
          context.description_en ||
          context.descriptionEn ||
          (state.config && state.config.descriptionEn) ||
          DEFAULT_PRODUCT_DESCRIPTION_EN,
        hs_code:
          context.hs_code ||
          context.hsCode ||
          (state.config && state.config.hsCode) ||
          DEFAULT_HS_CODE,
      },
      pricingData,
    );

    payload.cif_usd =
      payload.cif_usd == null ? null : toStringValue(payload.cif_usd);
    payload.cif_note =
      payload.cif_note == null ? null : toStringValue(payload.cif_note);

    return payload;
  }

  function isEnabled(context) {
    var activeContext = context || state.config || {};
    var countryCode =
      activeContext.countryCode ||
      activeContext.country ||
      DEFAULT_COUNTRY.code;

    return (
      activeContext.enabled !== false && countryCode === DEFAULT_COUNTRY.code
    );
  }

  function saveFiscalState(record) {
    state.record = record;

    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch (error) {
      console.warn(
        "[EusariFiscalColombia] Unable to persist transient state.",
        error,
      );
    }

    return record;
  }

  function clearFiscalState(reason) {
    state.record = null;
    state.pendingSubmit = null;
    state.pendingCartAdd = null;
    state.isProcessing = false;

    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.warn(
        "[EusariFiscalColombia] Unable to clear transient state.",
        error,
      );
    }

    document.dispatchEvent(
      new CustomEvent("eusari:fiscal-colombia:cleared", {
        detail: { reason: reason || "manual" },
      }),
    );
  }

  function clearPersistedFiscalState(reason) {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.warn(
        "[EusariFiscalColombia] Unable to clear persisted transient state.",
        error,
      );
    }

    document.dispatchEvent(
      new CustomEvent("eusari:fiscal-colombia:persisted-cleared", {
        detail: { reason: reason || "manual" },
      }),
    );
  }

  function resolveCheckoutUrl() {
    var routes = window.theme && window.theme.routes;
    var root = (routes && routes.root_url) || "/";

    if (root.charAt(root.length - 1) !== "/") root += "/";

    return root + DEFAULT_CHECKOUT_PATH;
  }

  function resolveCartRoute() {
    var routes = window.theme && window.theme.routes;
    var shopifyRoutes = window.Shopify && window.Shopify.routes;

    return (
      (routes && routes.cart) ||
      (shopifyRoutes && shopifyRoutes.root
        ? shopifyRoutes.root + "cart"
        : "/cart")
    );
  }

  function redirectToCheckout() {
    window.location.assign(resolveCheckoutUrl());
  }

  function suppressCartSurfaceUntilCheckout() {
    function suppressFiscalCartSurface(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    document.addEventListener(
      "theme:cart:popdown",
      suppressFiscalCartSurface,
      true,
    );
    document.addEventListener(
      "theme:cart:reload",
      suppressFiscalCartSurface,
      true,
    );

    return function releaseCartSurfaceSuppression() {
      document.removeEventListener(
        "theme:cart:popdown",
        suppressFiscalCartSurface,
        true,
      );
      document.removeEventListener(
        "theme:cart:reload",
        suppressFiscalCartSurface,
        true,
      );
    };
  }

  function createFiscalRecord(documentValue) {
    return saveFiscalState({
      country: DEFAULT_COUNTRY.code,
      countryName: DEFAULT_COUNTRY.name,
      document: normalizeDocument(documentValue),
      documentType: DEFAULT_COUNTRY.documentType,
      createdAt: new Date().toISOString(),
    });
  }

  function applyDocumentProperty(form, record) {
    var input;

    if (!form || !record || !record.document) return null;

    input = form.querySelector('input[name="properties[Documento Fiscal]"]');

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[Documento Fiscal]";
      input.setAttribute("data-fiscal-colombia-property", "documento-fiscal");
      form.appendChild(input);
    }

    input.value = record.document;
    return input;
  }

  async function syncFiscalLineProperty(record, productContext) {
    var context = productContext || {};
    var cartRoute = resolveCartRoute();
    var cartResponse = await fetch(cartRoute + ".js", {
      credentials: "same-origin",
    });
    var cart;
    var lineItem;
    var properties;
    var lineUpdateResponse;
    var updatedCart;
    var updatedLine;

    if (!cartResponse.ok) {
      throw new Error("Unable to synchronize Colombia fiscal line item.");
    }

    cart = await cartResponse.json();
    lineItem =
      context.line_item_key &&
      (cart.items || []).find(function findFiscalLine(item) {
        return item.key === context.line_item_key;
      });

    if (!lineItem) {
      throw new Error("Unable to synchronize Colombia fiscal line item.");
    }

    properties = Object.assign({}, lineItem.properties || {});
    properties["Documento Fiscal"] = record.document;
    lineUpdateResponse = await fetch(cartRoute + "/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: lineItem.key,
        quantity: lineItem.quantity,
        properties: properties,
      }),
    });

    if (!lineUpdateResponse.ok) {
      throw new Error("Unable to synchronize Colombia fiscal line item.");
    }

    updatedCart = await lineUpdateResponse.json();
    updatedLine = (updatedCart.items || []).find(function findUpdatedFiscalLine(
      item,
    ) {
      var itemProperties = item.properties || {};

      return (
        item.variant_id === lineItem.variant_id &&
        Object.keys(itemProperties).length === Object.keys(properties).length &&
        Object.keys(properties).every(function hasMatchingProperty(key) {
          return itemProperties[key] === properties[key];
        })
      );
    });

    if (!updatedLine || !updatedLine.key) {
      throw new Error("Unable to synchronize Colombia fiscal line item.");
    }

    context.line_item_key = updatedLine.key;
    return updatedCart;
  }

  async function sendFiscalWebhook(payload, options) {
    var requestOptions = options || {};
    var webhookUrl =
      requestOptions.webhookUrl || (state.config && state.config.webhookUrl);
    var timeoutMs = parseInt(requestOptions.timeoutMs, 10);
    var supportsAbort = typeof window.AbortController === "function";
    var controller = supportsAbort ? new window.AbortController() : null;
    var timeoutId;
    var timeoutPromise;
    var fetchPromise;
    var fetchOptions;
    var response;

    if (!(timeoutMs > 0)) timeoutMs = DEFAULT_WEBHOOK_TIMEOUT_MS;

    if (!webhookUrl) {
      console.warn(
        "[EusariFiscalColombia] Missing webhook URL; fiscal payload was not sent.",
      );
      return { ok: false, skipped: true, reason: "missing_webhook_url" };
    }

    try {
      timeoutPromise = new Promise(function resolveOnTimeout(resolve) {
        timeoutId = window.setTimeout(function abortWebhook() {
          if (controller) controller.abort();
          resolve({ ok: false, timedOut: true, reason: "timeout" });
        }, timeoutMs);
      });

      fetchOptions = {
        method: requestOptions.method || "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      };

      if (controller) fetchOptions.signal = controller.signal;

      fetchPromise = fetch(webhookUrl, fetchOptions);

      response = await Promise.race([fetchPromise, timeoutPromise]);

      if (timeoutId) window.clearTimeout(timeoutId);

      if (response && response.timedOut) {
        console.warn(
          "[EusariFiscalColombia] Fiscal webhook timed out without blocking checkout preparation.",
        );
        return response;
      }

      if (!response.ok) {
        console.warn(
          "[EusariFiscalColombia] Fiscal webhook responded with status " +
            response.status +
            ".",
        );
      }

      return { ok: response.ok, status: response.status };
    } catch (error) {
      if (timeoutId) window.clearTimeout(timeoutId);

      if (error && error.name === "AbortError") {
        console.warn(
          "[EusariFiscalColombia] Fiscal webhook timed out without blocking checkout preparation.",
        );
        return { ok: false, timedOut: true, reason: "timeout" };
      }

      console.error(
        "[EusariFiscalColombia] Fiscal webhook failed without blocking checkout preparation.",
        error,
      );
      return { ok: false, error: error };
    }
  }

  function sendFiscalWebhookInBackground(payload, options) {
    sendFiscalWebhook(payload, options)
      .then(function clearWebhookPersistence(webhookResult) {
        if (!webhookResult || webhookResult.ok !== true) {
          clearPersistedFiscalState(
            webhookResult && webhookResult.timedOut
              ? "webhook-timeout"
              : "webhook-failed",
          );
        } else {
          clearPersistedFiscalState("webhook-complete");
        }
      })
      .catch(function logUnexpectedWebhookError(error) {
        console.error(
          "[EusariFiscalColombia] Fiscal webhook background task failed without blocking checkout preparation.",
          error,
        );
        clearPersistedFiscalState("webhook-failed");
      });
  }

  function readRootConfig(root) {
    var configNode =
      root && root.querySelector("[data-fiscal-colombia-config]");
    var config = {
      enabled: true,
      countryCode: root && root.dataset.countryCode,
      countryName: root && root.dataset.countryName,
      templateScope: root && root.dataset.templateScope,
      webhookUrl: root && root.dataset.webhookUrl,
      webhookMethod: "POST",
    };

    if (configNode && configNode.textContent) {
      try {
        config = Object.assign(config, JSON.parse(configNode.textContent));
      } catch (error) {
        console.warn(
          "[EusariFiscalColombia] Unable to parse fiscal config JSON.",
          error,
        );
      }
    }

    return config;
  }

  function setModalOpen(root, isOpen) {
    var modal = root.querySelector("[data-fiscal-colombia-modal]");

    if (!modal) return;

    modal.hidden = !isOpen;
    document.documentElement.classList.toggle(
      "fiscal-colombia-is-open",
      isOpen,
    );
  }

  function setProcessingState(root, isProcessing) {
    var form = root && root.querySelector("[data-fiscal-colombia-form]");
    var processing =
      root && root.querySelector("[data-fiscal-colombia-processing]");
    var submit = root && root.querySelector("[data-fiscal-colombia-submit]");
    var cancel = root && root.querySelector("[data-fiscal-colombia-cancel]");

    if (form) form.hidden = Boolean(isProcessing);
    if (processing) processing.hidden = !isProcessing;
    if (submit) submit.disabled = Boolean(isProcessing);
    if (cancel) cancel.disabled = Boolean(isProcessing);

    if (root && isProcessing) setModalOpen(root, true);
  }

  function hideProcessingState() {
    var root = document.querySelector("[data-fiscal-colombia-root]");

    if (!root) return;

    setProcessingState(root, false);
    setModalOpen(root, false);
  }

  function showError(root, message) {
    var input = root.querySelector("[data-fiscal-colombia-document]");
    var error = root.querySelector("[data-fiscal-colombia-error]");

    if (input) input.classList.toggle("is-invalid", Boolean(message));
    if (error) error.textContent = message || "";
  }

  function showFormError(form, message) {
    var boundary =
      form &&
      (form.querySelector("[data-error-boundary]") ||
        form.closest("[data-error-boundary]"));
    var errorDisplay =
      boundary && boundary.querySelector("[data-error-display]");

    if (!errorDisplay) return;

    errorDisplay.innerHTML = message
      ? '<div class="errors">' + message + "</div>"
      : "";
    errorDisplay.hidden = !message;
  }

  function getCartAddUrl() {
    return resolveCartRoute() + "/add.js";
  }

  async function addFiscalProductToCart(form) {
    var formData = new FormData(form);
    var response = await fetch(getCartAddUrl(), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(formData).toString(),
    });

    if (!response.ok) {
      throw new Error("Unable to add Colombia fiscal product to cart.");
    }

    return response.json();
  }

  function bindModal(root) {
    var form = root.querySelector("[data-fiscal-colombia-form]");
    var input = root.querySelector("[data-fiscal-colombia-document]");
    var cancel = root.querySelector("[data-fiscal-colombia-cancel]");

    if (!form || root.dataset.fiscalColombiaBound === "true") return;

    root.dataset.fiscalColombiaBound = "true";

    form.addEventListener("submit", function onFiscalSubmit(event) {
      var record;

      event.preventDefault();

      if (!validateFiscalDocument(input && input.value)) {
        showError(root, "Ingresa un NIT o Cédula válido para Colombia.");
        return;
      }

      if (state.isProcessing) {
        return;
      }

      state.isProcessing = true;
      record = createFiscalRecord(input.value);
      showError(root, "");
      setProcessingState(root, true);

      if (typeof state.pendingSubmit === "function") {
        state.pendingSubmit(record);
      } else {
        state.isProcessing = false;
        setProcessingState(root, false);
      }
    });

    if (input) {
      input.addEventListener("input", function onFiscalInput() {
        showError(root, "");
      });
    }

    if (cancel) {
      cancel.addEventListener("click", function onFiscalCancel() {
        clearFiscalState("cancel");
        setProcessingState(root, false);
        setModalOpen(root, false);
      });
    }
  }

  function openModal(options) {
    var root =
      (options && options.root) ||
      document.querySelector("[data-fiscal-colombia-root]");
    var input;

    if (!root)
      return Promise.reject(new Error("Colombia fiscal root was not found."));

    bindModal(root);
    setProcessingState(root, false);
    setModalOpen(root, true);

    input = root.querySelector("[data-fiscal-colombia-document]");
    if (input)
      window.setTimeout(function focusInput() {
        input.focus();
      }, 50);

    return new Promise(function waitForRecord(resolve) {
      state.pendingSubmit = resolve;
    });
  }

  function findControlledForms(root) {
    var scope = root && root.closest('[data-menoplay-pdp-module="hero"]');

    if (!scope) scope = document;

    return Array.prototype.slice.call(
      scope.querySelectorAll(
        'form[data-product-form][data-fiscal-colombia-form="true"]',
      ),
    );
  }

  function findFormControl(form, name) {
    var control;
    var escapedFormId;

    if (!form) return null;

    control = form.elements && form.elements.namedItem(name);
    if (control && control.length && !control.value) control = control[0];
    if (control) return control;

    control = form.querySelector('[name="' + name + '"]');
    if (control || !form.id) return control;

    escapedFormId =
      window.CSS && typeof window.CSS.escape === "function"
        ? window.CSS.escape(form.id)
        : form.id.replace(/(["\\])/g, "\\$1");

    return document.querySelector(
      '[name="' + name + '"][form="' + escapedFormId + '"]',
    );
  }

  function getFormProductContext(form) {
    var idInput = findFormControl(form, "id");
    var quantityInput = findFormControl(form, "quantity");

    return {
      variant_id: idInput && idInput.value,
      product_id: state.config && state.config.productId,
      pack_quantity: quantityInput && quantityInput.value,
      description_es: state.config && state.config.descriptionEs,
      description_en: state.config && state.config.descriptionEn,
      hs_code: state.config && state.config.hsCode,
    };
  }

  async function continueFiscalCheckout(form, record, productContext, options) {
    var requestOptions = options || {};
    var releaseCartSurfaceSuppression = suppressCartSurfaceUntilCheckout();
    var addedItem;

    try {
      state.isProcessing = true;
      showFormError(form, "");

      if (!requestOptions.skipAddToCart) {
        addedItem = await addFiscalProductToCart(form);
        productContext = Object.assign({}, productContext, {
          line_item_key: addedItem && addedItem.key,
        });
        state.pendingCartAdd = {
          record: record,
          productContext: productContext,
        };
      }

      await syncFiscalLineProperty(record, productContext);

      clearFiscalState("checkout-redirect");
      releaseCartSurfaceSuppression();
      redirectToCheckout();
    } catch (error) {
      console.warn(
        "[EusariFiscalColombia] Colombia fiscal checkout preparation failed; checkout redirect was not started.",
        error,
      );
      releaseCartSurfaceSuppression();
      state.isProcessing = false;
      hideProcessingState();

      if (requestOptions.skipAddToCart || state.pendingCartAdd) {
        showFormError(
          form,
          "No pudimos guardar la información fiscal en el producto. El producto ya puede estar agregado; vuelve a intentar para guardar el Documento Fiscal y continuar al checkout sin duplicarlo.",
        );
      } else {
        clearFiscalState("cart-add-failed");
        showFormError(
          form,
          "No pudimos agregar el producto al carrito. Revisa tu conexión e intenta nuevamente.",
        );
      }
    }
  }

  function bindControlledProductForms(root) {
    if (!isEnabled(state.config)) return;

    findControlledForms(root).forEach(function bindForm(form) {
      if (form.dataset.fiscalColombiaSubmitBound === "true") return;

      form.dataset.fiscalColombiaSubmitBound = "true";

      form.addEventListener(
        "submit",
        function onControlledSubmit(event) {
          var productContext;
          var pendingAdd;

          event.preventDefault();
          event.stopImmediatePropagation();

          if (state.isProcessing) {
            return;
          }

          pendingAdd = state.pendingCartAdd;

          if (pendingAdd && pendingAdd.record) {
            setProcessingState(root, true);
            applyDocumentProperty(form, pendingAdd.record);
            continueFiscalCheckout(
              form,
              pendingAdd.record,
              pendingAdd.productContext || getFormProductContext(form),
              { skipAddToCart: true },
            );
            return;
          }

          openModal({ root: root })
            .then(function onFiscalRecord(record) {
              productContext = getFormProductContext(form);

              applyDocumentProperty(form, record);
              sendFiscalWebhookInBackground(
                buildWebhookPayload(record, productContext),
                {
                  webhookUrl: state.config && state.config.webhookUrl,
                  method: state.config && state.config.webhookMethod,
                },
              );

              return continueFiscalCheckout(form, record, productContext);
            })
            .catch(function onFiscalError(error) {
              console.error(
                "[EusariFiscalColombia] Colombia fiscal preparation failed before add-to-cart.",
                error,
              );
              clearFiscalState("preparation-error");
              hideProcessingState();
              showFormError(
                form,
                "No pudimos preparar la información fiscal. Intenta nuevamente.",
              );
            });
        },
        true,
      );
    });
  }

  function init(root) {
    var targetRoot =
      root ||
      document.querySelector("[data-fiscal-colombia-root]") ||
      document.querySelector("[data-fiscal-colombia-drawer-config-root]");
    var isUiRoot;

    if (!targetRoot) return null;

    isUiRoot = targetRoot.hasAttribute("data-fiscal-colombia-root");
    state.config = readRootConfig(targetRoot);

    if (!isEnabled(state.config)) {
      clearFiscalState("scope-disabled");
      return state.config;
    }

    if (isUiRoot) {
      bindModal(targetRoot);
      bindControlledProductForms(targetRoot);
    }
    return state.config;
  }

  window[MODULE_NAME] = {
    isEnabled: isEnabled,
    init: init,
    openModal: openModal,
    validateFiscalDocument: validateFiscalDocument,
    normalizeDocument: normalizeDocument,
    buildWebhookPayload: buildWebhookPayload,
    sendFiscalWebhook: sendFiscalWebhook,
    applyDocumentProperty: applyDocumentProperty,
    syncFiscalLineProperty: syncFiscalLineProperty,
    syncCartNote: syncFiscalLineProperty,
    resolveCheckoutUrl: resolveCheckoutUrl,
    clearFiscalState: clearFiscalState,
    createFiscalRecord: createFiscalRecord,
    getColombiaPackData: getColombiaPackData,
    getFormProductContext: getFormProductContext,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function onReady() {
      init();
    });
  } else {
    init();
  }
})(window, document);
